module.exports = __webpack_public_path__ + "img/4.84ef0a1f.png";